import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {ProjectProvider} from "./context/project-context";
import {RouterProvider} from "react-router-dom";
import {router} from "./router"
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import "react-toastify/dist/ReactToastify.css";
import Loading from "./pages/loading";

const client = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <ProjectProvider>
        <QueryClientProvider client={client}>
            <RouterProvider router={router} fallbackElement={<Loading />}/>
        </QueryClientProvider>
    </ProjectProvider>
);

reportWebVitals();
